<script>
import * as constants from '@/utilities/appConsts'

export default {
  methods: {
    getStatusAlertCountValue(item) {
      let statusValue = 3
      if (
        item.status === constants.STATUS_VALUES.lowWarning ||
        item.status === constants.STATUS_VALUES.highWarning ||
        item.status === constants.STATUS_VALUES.highLowWarning ||
        item.status === constants.STATUS_VALUES.eventWarning
      ) {
        statusValue = 1
      }
      if (
        item.status === constants.STATUS_VALUES.lowCaution ||
        item.status === constants.STATUS_VALUES.highCaution ||
        item.status === constants.STATUS_VALUES.highLowCaution ||
        item.status === constants.STATUS_VALUES.eventCaution
      ) {
        statusValue = 2
      }
      return `${statusValue}`
    },
    isValidStatus(status) {
      if (status === constants.STATUS_VALUES.lowWarning) {
        return true
      }
      if (status === constants.STATUS_VALUES.lowCaution) {
        return true
      }
      if (status === constants.STATUS_VALUES.highCaution) {
        return true
      }
      if (status === constants.STATUS_VALUES.highWarning) {
        return true
      }
      if (status === constants.STATUS_VALUES.highLowWarning) {
        return true
      }
      if (status === constants.STATUS_VALUES.highLowCaution) {
        return true
      }
      if (status === constants.STATUS_VALUES.eventWarning) {
        return true
      }
      if (status === constants.STATUS_VALUES.eventCaution) {
        return true
      }
      return false
    },
    getStatusTitle(status) {
      if (status === constants.STATUS_VALUES.lowWarning) {
        return constants.STATUS_TITLES.lowWarning
      }
      if (status === constants.STATUS_VALUES.lowCaution) {
        return constants.STATUS_TITLES.lowCaution
      }
      if (status === constants.STATUS_VALUES.highCaution) {
        return constants.STATUS_TITLES.highCaution
      }
      if (status === constants.STATUS_VALUES.highWarning) {
        return constants.STATUS_TITLES.highWarning
      }
      if (status === constants.STATUS_VALUES.highLowWarning) {
        return constants.STATUS_TITLES.highLowWarning
      }
      if (status === constants.STATUS_VALUES.highLowCaution) {
        return constants.STATUS_TITLES.highLowCaution
      }
      if (status === constants.STATUS_VALUES.eventWarning) {
        return constants.STATUS_TITLES.eventWarning
      }
      if (status === constants.STATUS_VALUES.eventCaution) {
        return constants.STATUS_TITLES.eventCaution
      }
      return ''
    },
  },
}
</script>
